import type { LineItemType } from '@weft/types';
import { LINE_ITEM_TYPES } from '@weft/types';

export const PRODUCT_LINE_ITEM_TYPES: LineItemType[] = [
  LINE_ITEM_TYPES.Fixed,
  LINE_ITEM_TYPES.Usage,
  LINE_ITEM_TYPES.Commitment,
];